import {useSelector} from "react-redux";
import HashtagIcon from "assets/icons/Hashtag";
import "../../Factor2/print/fishPrint.css";
import {formatPrice} from "helpers";
import {useRef} from "react";

export default function useAccountingPrint(props?: { accounting?: any }) {
    const store = useSelector((state: any) => state);
    const accounting = props?.accounting || store.accountingReducer?.accounting;
    const business = store.businessReducer.business.business;
    const contentRef = useRef<any>(null);
    let content = <></>;
    if (accounting) {
        content = (
            <div
                className="bg-white flex flex-col items-center text-black p-5"
                ref={contentRef}
                style={{direction: "rtl", lineHeight: '30px'}}
            >
                <div className="w-full row">
                    <div className="col-4"></div>
                    <div className="col-4">
                        <div className="text-[20px] font-extrabold text-center pb-1">سند حسابداری</div>
                        <div className="text-[16px] font-extrabold text-center pb-1">{business.legalName}</div>
                    </div>
                    <div className="text-left col-4">
                        <div className="text-[16px] text-left pb-1">شماره سند: {accounting.accountingCode}</div>
                        <div className="text-[16px] text-left pb-1">ارجاع: {accounting.reference}</div>
                        <div className="text-[16px] pb-1">تاریخ: {accounting.date}</div>
                    </div>
                </div>

                <div className="w-full row border-2  border-[#000]">
                    <div className="row">
                        <div className="col-12 flex flex-row">
                            <p>شرح سند:</p>
                            <p className="mr-3">{accounting.description}</p>
                        </div>
                    </div>
                </div>

                <div className="w-full row border-2  border-[#000] mt-4 border-bottom-0">
                    <table
                        className="w-full table-bordered" style={{lineHeight: '30px'}}>
                        <thead>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}>
                            <HashtagIcon color="black" style={{transform: "scale(1.0)"}}/>
                        </th>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}
                            className="w-[140px]">کد حساب
                        </th>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}>شرح
                        </th>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}>بدهکار
                        </th>
                        <th style={{
                            fontSize: "12px", borderLeft: "2px solid black",
                            borderBottom: "2px solid black",
                            padding: "3px",
                            textAlign: 'center'
                        }}>بستانکار
                        </th>
                        </thead>
                        <tbody>
                        {accounting?.Accounting_Items?.map((item: any, i: number) => {
                            return (
                                <tr key={i}>
                                    <td className="text-center font-semibold" style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>{i + 1}</td>
                                    <td className="px-0 py-1"
                                        style={{
                                            borderLeft: "2px solid black",
                                            borderBottom: "2px solid black",
                                            padding: "3px",
                                            textAlign: 'center'
                                        }}>
                                        <p className="text-xs font-semibold">{`${item.accountType}-${item?.Account_Type?.code}` }</p>
                                        <p className="text-xs font-semibold">{item.detail}</p>
                                    </td>
                                    <td style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>
                                        <span className="flex justify-center">{item.description}</span>
                                    </td>
                                    <td style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>
                                        <span>{item.isCreditor ? 0 : formatPrice(item.amount)}</span>
                                    </td>
                                    <td style={{
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>
                                        <span>{item.isCreditor ? formatPrice(item.amount) : 0}</span>
                                    </td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td colSpan={3} className="font-semibold"
                                style={{
                                    borderBottom: "2px solid black",
                                    borderLeft: "2px solid black",
                                    padding: "3px",
                                    textAlign: 'center'
                                }}>جمع
                            </td>
                            <td className="font-semibold"
                                style={{
                                    borderBottom: "2px solid black",
                                    borderLeft: "2px solid black",
                                    padding: "3px",
                                    textAlign: 'center'
                                }}>
                                <span>{formatPrice(accounting.Accounting_Items.reduce((acc: any, item: {
                                    isCreditor: any;
                                    amount: any;
                                }) => acc + (item.isCreditor ? 0 : item.amount), 0))}</span>
                            </td>
                            <td className="font-semibold"
                                style={{
                                    borderBottom: "2px solid black",
                                    padding: "3px",
                                    textAlign: 'center'
                                }}>
                                <span>{formatPrice(accounting.Accounting_Items.reduce((acc: any, item: {
                                    isCreditor: any;
                                    amount: any;
                                }) => acc + (item.isCreditor ? item.amount : 0), 0))}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="w-full row mt-4" style={{height: '100px'}}>
                    <div className="col-4 border-2 border-[#000]" style={{borderLeft: 0}}>
                        <p>صادر کننده</p>
                    </div>
                    <div className="col-4 border-2  border-[#000]" style={{borderLeft: 0}}>
                        <p>بررسی کننده</p>
                    </div>
                    <div className="col-4 border-2  border-[#000]">
                        <p>تایید کننده</p>
                    </div>
                </div>
            </div>
        );
    }
    return {content, contentRef};
}
